export function defineEndpointDirectory(endpointDirectory) {
    const { envName, rotatingVerifySecret, preview } = endpointDirectory;
    return {
        id: `endpoint-directory`,
        optionalDependencies: {
            featureServices: {
                's2:logger': `^1.0.0`,
            },
        },
        create: ({ featureServices }) => {
            const { 's2:logger': logger = console } = featureServices;
            return {
                '1.0.0': (consumerId, consumerName) => {
                    assertIsEnvNameV1(envName, consumerId, consumerName);
                    logger.warn(`DEPRECATED: Version 1.0.0 of the endpoint directory is deprecated. The consumer ${printConsumerInfo({ consumerId, consumerName })} should use 3.0.0 instead.`);
                    return {
                        featureService: {
                            envName,
                            preview,
                            restApiAuthHeader: rotatingVerifySecret,
                        },
                    };
                },
                '2.0.0': (consumerId, consumerName) => {
                    assertIsEnvNameV1(envName, consumerId, consumerName);
                    logger.warn(`DEPRECATED: Version 2.0.0 of the endpoint directory is deprecated. The consumer ${printConsumerInfo({ consumerId, consumerName })} should use 3.0.0 instead.`);
                    return { featureService: { envName, preview, rotatingVerifySecret } };
                },
                '3.0.0': () => ({ featureService: endpointDirectory }),
            };
        },
    };
}
function assertIsEnvNameV1(envName, consumerId, consumerName) {
    if (envName === `sit`) {
        throw new Error(`The consumer ${printConsumerInfo({
            consumerId,
            consumerName,
        })} must use 3.0.0 of the endpoint directory to support the SIT environment.`);
    }
}
function printConsumerInfo({ consumerId, consumerName }) {
    return `"${consumerId}"${consumerName ? ` ("${consumerName}")` : ``}`;
}
//# sourceMappingURL=index.js.map